import gql from 'graphql-tag';

export default gql`
fragment BannerListItemFragment on AdminBanner {
    id
    name
    active_from
    active_to
    is_active
    banner_places {
        id
        name
    }
}
`;


// WEBPACK FOOTER //
// ./src/api/graphql/fragments/BannerListItemFragment.ts